import api from '@/apis/di/accountAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Tài khoản kho
export const useAccountStockComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onAccountStockComboboxLoadData = (payload, row, column) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [
      { Field: 'is_detail_by_inventory_item', Value: true },
      { Field: 'inactive', Value: false, Ors: ors },
    ];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'account_number';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const accountStockComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'account_number',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      { title: 'Tên tài khoản', dataField: 'account_name', filterOperator: proxy.$ms.constant.FilterOperator.Contains,width: 480 },
    ],
    displayField: 'account_number',
    valueField: 'account_number',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onAccountStockComboboxLoadData,
  };

  return {
    accountStockComboConfig,
    onAccountStockComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
